import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue') 
const Pagamento = () => import('./Pagamento.vue') 

export default {
    path: 'pagamentos',
    name: 'DespesasGerais_Demandantes_Pagamentos',
    component: Pagamentos,
    beforeEnter(to, from, next) {
        if (temAcesso('DESP-GERAIS-DEMAN-PAG-00')) {
            next();
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'DespesasGerais_Demandantes_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-DEMAN-PAG-01')) {
                    next()
                }
            },
        },
    ]
}